export default {
    getFileInfo(state){
        return state.upload.file;
    },
    getFileResponse(state){
        return state.upload.response;
    }
}